import { render, staticRenderFns } from "./metatag-variables-form.vue?vue&type=template&id=17c8dd28&"
import script from "./metatag-variables-form.vue?vue&type=script&lang=js&"
export * from "./metatag-variables-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports